var $3ed876b500650109$exports = {};
$3ed876b500650109$exports = {
    "help": `Pomoc`,
    "info": `Informacja`
};


export {$3ed876b500650109$exports as default};
//# sourceMappingURL=pl-PL.module.js.map
